import { AppRouteProps } from "@bsm/component";
import React from "react";

const StudentCreationContainer = React.lazy(() => import('./containers/StudentCreationContainer'))

export const StudentCreationRoutes: Array<AppRouteProps> = [
    {
        path: 'create',
        // title: '{{StudentNameFull}}',
        element: <StudentCreationContainer />,
        children: []
    }
]